import { createEntity } from '@luna/api';
import type { Color } from '@api-client/products';
import { ColorsService } from '@api-client/products';

export const colorsEntity = createEntity({
    name: '@products/aggregation/customization/colors',
    withEntityType: {} as Color,
    payloadCreators: {
        queryAll: async (): Promise<Color[]> => {
            const { items = [] } = await ColorsService.getPublicProductsCustomizationColors();

            return items;
        },
    },
});
